import React from "react";
import { Layout } from "../components/layout";
import { SEO } from "../components/common";

export function TermsPage() {
  return (
    <Layout fullWidth>
      <SEO
        title="Terms of Service | Block Pattern Generator"
        description="Read our terms of service and usage guidelines for Block Pattern Generator. Understanding your rights and responsibilities."
        keywords={[
          "terms of service",
          "usage terms",
          "service agreement",
          "wordpress blocks terms",
        ]}
      />
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-white mb-8">Terms of Service</h1>

        <div className="bg-gray-800/50 rounded-xl p-8">
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-400 italic">
              This is a placeholder for your terms of service content. Please
              replace this with your actual terms of service.
            </p>

            <div className="space-y-6 text-gray-300">
              <section>
                <h2 className="text-xl font-semibold text-white">
                  1. Acceptance of Terms
                </h2>
                <p>Placeholder for terms acceptance policy.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  2. Description of Service
                </h2>
                <p>Placeholder for service description.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  3. User Obligations
                </h2>
                <p>Placeholder for user obligations.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  4. Intellectual Property Rights
                </h2>
                <p>Placeholder for IP rights information.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  5. Limitation of Liability
                </h2>
                <p>Placeholder for liability limitations.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white">
                  6. Governing Law
                </h2>
                <p>Placeholder for governing law information.</p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
